import { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';

const SOCKET_SERVER_URL = process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, '') || 'http://localhost:3300';

/**
 * Shared Socket.IO connection. Returns a live socket instance (re-renders when connected).
 */
export function useSocket() {
  const socketRef = useRef(null);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const instance = io(SOCKET_SERVER_URL, {
      transports: ['websocket'],
      auth: {
        token: localStorage.getItem('token') || undefined
      }
    });
    socketRef.current = instance;
    setSocket(instance);

    return () => {
      instance.disconnect();
      socketRef.current = null;
      setSocket(null);
    };
  }, []);

  return socket;
}

export default useSocket;
